import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import { PutawayHubInitialStateType } from 'features/SupplyOrder/pages/PutawayHub/@types'
import { SLICE_NAME, fetchPutawayHubList, fetchLocations, fetchResetPutawayHubItem } from './thunk'

const initialState: PutawayHubInitialStateType = {
  isLoading: false,
  data: [],
  totalData: 0,
  constants: { locations: [] },
}

const putawayHubSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetPutawayHubState: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<PutawayHubInitialStateType>) => {
      builder.addCase(fetchPutawayHubList.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.totalData = action.payload.data.length
      })
      builder.addCase(fetchLocations.fulfilled, (state, action) => {
        state.constants.locations = action.payload
      })
    },
    [fetchPutawayHubList, fetchResetPutawayHubItem, fetchLocations],
  ),
})

export const { resetPutawayHubState } = putawayHubSlice.actions
export default putawayHubSlice.reducer
